package com.example.compose
import androidx.compose.ui.graphics.Color

val primaryDark = Color(0xFFFF7A00)
val onPrimaryDark = Color(0xFF1F0B00)
val primaryContainerDark = Color(0xFF4A2400)
val onPrimaryContainerDark = Color(0xFFFFD9B8)
val secondaryDark = Color(0xFF35D0E2)
val onSecondaryDark = Color(0xFF001F25)
val secondaryContainerDark = Color(0xFF004A53)
val onSecondaryContainerDark = Color(0xFFA8EDF5)
val tertiaryDark = Color(0xFF9CB2FF)
val onTertiaryDark = Color(0xFF00144F)
val tertiaryContainerDark = Color(0xFF2F3B85)
val onTertiaryContainerDark = Color(0xFFE0E4FF)
val errorDark = Color(0xFFFFB4AB)
val onErrorDark = Color(0xFF690005)
val errorContainerDark = Color(0xFF93000A)
val onErrorContainerDark = Color(0xFFFFDAD6)
val backgroundDark = Color(0xFF0E1116)
val onBackgroundDark = Color(0xFFE6ECF3)
val surfaceDark = Color(0xFF131922)
val onSurfaceDark = Color(0xFFE6ECF3)
val surfaceVariantDark = Color(0xFF2B3340)
val onSurfaceVariantDark = Color(0xFFC3CAD6)
val outlineDark = Color(0xFF8E96A3)
val outlineVariantDark = Color(0xFF2B3340)
val scrimDark = Color(0xFF000000)
val inverseSurfaceDark = Color(0xFFE6ECF3)
val inverseOnSurfaceDark = Color(0xFF131922)
val inversePrimaryDark = Color(0xFFC86419)
val surfaceDimDark = Color(0xFF0F141C)
val surfaceBrightDark = Color(0xFF1D2530)
val surfaceContainerLowestDark = Color(0xFF0A0D12)
val surfaceContainerLowDark = Color(0xFF121922)
val surfaceContainerDark = Color(0xFF181F29)
val surfaceContainerHighDark = Color(0xFF1F2630)
val surfaceContainerHighestDark = Color(0xFF262E39)
